











































































































import Vue from "vue";
import Component from "vue-class-component";
import {ValidationObserver, ValidationProvider} from "vee-validate";
import {getDocument, setDocument} from "@/common/js/firestore-utils";
import {IProvider, Provider} from "@/data/Provider";
import {Prop} from "vue-property-decorator";
import Messages from "@/components/Messages.vue";

@Component({
    components: {
        ValidationProvider,
        ValidationObserver
    }
})
export default class ProviderInfoView extends Vue {
    @Prop({required: true})
    readonly providerId!: string;

    loading: boolean = false;
    disabled: boolean = false;
    editing: boolean = false;

    provider: IProvider = new Provider().copy({});

    editedProvider: IProvider = new Provider().copy({});

    get messages(): Messages {
        return this.$inject("messages");
    }

    async mounted() {
        this.loading = true;
        this.disabled = true;
        try {
            this.provider = await getDocument<IProvider>(this.providerId, {collectionPath: "/providers"});
            this.disabled = false;
        } catch (error) {
            await this.messages.showError(this.$t("views.provider-info.messages.could-not-get-provider-data") as string);
        }
        this.loading = false;
    }

    openEdit() {
        this.editing = true;
        Provider.copy(this.provider, this.editedProvider);
    }

    async submit() {
        this.loading = true;
        this.disabled = true;
        try {
            await setDocument(this.editedProvider, {collectionPath: "/providers"});
            Provider.copy(this.editedProvider, this.provider);
            await this.messages.showSuccess(this.$t("views.provider-info.messages.save-success") as string);
            this.editing = false;
        } catch (error) {
            await this.messages.showError(this.$t("views.provider-info.messages.could-not-save-provider-data") as string);
        }
        this.loading = false;
        this.disabled = false;
    }
}
